import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { initGA, logPageView } from './analytics';
import HomePage from "./pages/HomePage";
import AuthPage from "./pages/AuthPage";
import DashboardPage from "./pages/DashboardPage";
import JobDetailPage from "./pages/JobDetailPage";
import JobsPublicPage from "./pages/JobsPublicPage";
import FavoritesPage from "./pages/FavoritesPage";
import AlertsPage from "./pages/AlertsPage";
import CompaniesPage from "./pages/CompaniesPage";
import AdSenseConfigPage from "./pages/AdSenseConfigPage";
import JobsAdminPage from "./pages/JobsAdminPage";
import AnunciosPage from "./pages/AnunciosPage";
import AnuncioDetailPage from "./pages/AnuncioDetailPage";
import CreateAnuncioPage from "./pages/CreateAnuncioPage";
import MisAnunciosPage from "./pages/MisAnunciosPage";
import BlogListPage from "./pages/BlogListPage";
import BlogPostPage from "./pages/BlogPostPage";
import BlogEditorPage from "./pages/BlogEditorPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import CookiePolicyPage from "./pages/CookiePolicyPage";
import TermsPage from "./pages/TermsPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import CookieBanner from "./components/CookieBanner";
import { Toaster } from "@/components/ui/sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export { API };

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
    
    // Initialize Google Analytics
    initGA();
    logPageView();
  }, []);

  const checkAuth = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        setLoading(false);
        return;
      }

      const response = await fetch(`${API}/auth/me`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        credentials: "include",
      });

      if (response.ok) {
        const userData = await response.json();
        setUser(userData);
      } else {
        localStorage.removeItem("token");
      }
    } catch (error) {
      console.error("Auth check failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const ProtectedRoute = ({ children }) => {
    if (loading) return <div className="flex items-center justify-center min-h-screen">Cargando...</div>;
    return user ? children : <Navigate to="/auth" />;
  };

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">Cargando...</div>;
  }

  return (
    <div className="App">
      <Toaster position="top-center" />
      <BrowserRouter>
        <CookieBanner />
        <Routes>
          <Route path="/" element={<HomePage user={user} />} />
          <Route path="/auth" element={user ? <Navigate to="/dashboard" /> : <AuthPage setUser={setUser} />} />
          <Route path="/ofertas" element={<JobsPublicPage />} />
          <Route path="/ofertas/:jobId" element={<JobDetailPage user={user} />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage user={user} setUser={setUser} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobs/:jobId"
            element={<JobDetailPage user={user} />}
          />
          <Route
            path="/favorites"
            element={
              <ProtectedRoute>
                <FavoritesPage user={user} setUser={setUser} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/alerts"
            element={
              <ProtectedRoute>
                <AlertsPage user={user} setUser={setUser} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/companies"
            element={
              <ProtectedRoute>
                <CompaniesPage user={user} setUser={setUser} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/adsense"
            element={
              <ProtectedRoute>
                <AdSenseConfigPage user={user} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/jobs"
            element={
              <ProtectedRoute>
                <JobsAdminPage user={user} token={localStorage.getItem('token')} />
              </ProtectedRoute>
            }
          />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/cookie-policy" element={<CookiePolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/quienes-somos" element={<AboutPage />} />
          <Route path="/contacto" element={<ContactPage />} />
          
          {/* Blog (New System) */}
          <Route path="/blog" element={<BlogListPage user={user} />} />
          <Route path="/blog/:slug" element={<BlogPostPage user={user} />} />
          <Route 
            path="/blog/editor" 
            element={
              <ProtectedRoute>
                <BlogEditorPage user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/blog/editor/:postId" 
            element={
              <ProtectedRoute>
                <BlogEditorPage user={user} />
              </ProtectedRoute>
            } 
          />
          
          {/* Tablón de Anuncios */}
          <Route path="/anuncios" element={<AnunciosPage user={user} />} />
          <Route path="/anuncios/:id" element={<AnuncioDetailPage user={user} />} />
          <Route 
            path="/publicar-anuncio" 
            element={<CreateAnuncioPage user={user} />} 
          />
          <Route 
            path="/mis-anuncios" 
            element={
              <ProtectedRoute>
                <MisAnunciosPage user={user} />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;// Blog v2: 20260131-1855
